import { render, staticRenderFns } from "./parkmessage.vue?vue&type=template&id=de4c388c&"
import script from "./parkmessage.vue?vue&type=script&lang=js&"
export * from "./parkmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports